import { render, staticRenderFns } from "./member-costs.vue?vue&type=template&id=87b582aa&scoped=true"
import script from "./member-costs.vue?vue&type=script&lang=js"
export * from "./member-costs.vue?vue&type=script&lang=js"
import style0 from "./member-costs.vue?vue&type=style&index=0&id=87b582aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b582aa",
  null
  
)

export default component.exports